import { Component, EventEmitter, Input, Output, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { KeyValue } from '@angular/common';

@Component({
  selector: 'app-service-management-row',
  templateUrl: './service-management-row.component.html',
  styleUrls: ['./service-management-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ServiceManagementRowComponent implements OnInit, OnDestroy {
  @Input() serviceRowForm: FormGroup;
  @Output() formServiceRowChange = new EventEmitter<void>();
  @Input() rowIndex: number;
  @Input() placementIdsList: KeyValue<string, string>[];
  readonly destroy$ = new Subject<void>();
  ngOnInit(): void {
    this.serviceRowForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.formServiceRowChange.emit();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
